import React from 'react';
import { Line } from '../Lines';
import { withNotifications } from '../../../common/notifications/NotificationsContext';
import { Price } from '../Price';

const Fees = ({ pricing }) => {
  const { destination, gasGuzzlerTax, acTax, dealerFee, miscFees } = pricing;

  return (
    <div className="math-box__fees">
      {destination && (
        <Line
          labelKey="component.pricing.destination"
          price={destination.text}
          className="fees-total"
        />
      )}
      {gasGuzzlerTax && (
        <Line
          labelKey="component.pricing.gas.guzzler.tax"
          price={gasGuzzlerTax.text}
          className="fees-total"
        />
      )}
      {acTax && (
        <Line
          labelKey="component.pricing.ac.tax"
          price={acTax.text}
          className="fees-total"
        />
      )}
      {dealerFee && (
        <Line
          labelKey="component.pricing.dealer.fees"
          price={dealerFee.text}
          className="fees-total"
        />
      )}
      {miscFees && (
        <>
          {miscFees.map((fee) => (
            <Line
              key={fee.label}
              label={fee.label}
              price={fee.cw.text}
              disclaimer={fee.disclaimer}
              className="fees-total"
            />
          ))}
        </>
      )}
    </div>
  );
};

const AboveTheLineFee = ({ fee, notifications, showSign }) => {
  const { show } = notifications;

  const onOpenDisclosure = (event) => {
    event.preventDefault();
    show(feeDisclaimers, event);
  };

  let feeDisclaimers = '';

  fee.disclaimers?.map((disclaimer) => (feeDisclaimers += disclaimer + '<br>'));

  return (
    <div className="above-the-line-fee">
      <div className="above-the-line-fee__program">
        <div className="above-the-line-fee__event-name">{fee.program}</div>
        {feeDisclaimers ? (
          <button
            className="above-the-line-fee__disclosure"
            onClick={onOpenDisclosure}>
            <Price
              className="above-the-line-fee"
              value={fee.value}
              showSign={showSign}
            />
            <span className="above-the-line-fee__disclaimer-dagger">†</span>
          </button>
        ) : (
          <Price
            className="above-the-line-fee"
            value={fee.value}
            onClick={onOpenDisclosure}
            showSign={showSign}
          />
        )}
      </div>
    </div>
  );
};

const AboveTheLineFees = withNotifications(({ pricing, notifications }) => {
  const { luxuryTax } = pricing;
  const { disclaimer: fltDisclaimer, cw: fltCw, label: fltLabel } =
    luxuryTax ?? {};

  const luxuryTaxFee = luxuryTax && {
    disclaimers: fltDisclaimer ? [fltDisclaimer] : [],
    value: fltCw?.value,
    program: fltLabel,
  };

  const fees = luxuryTaxFee ? [luxuryTaxFee] : [];
  const feeLines = fees.map((fee, index) => (
    <AboveTheLineFee
      key={`fee-${index}`}
      fee={fee}
      notifications={notifications}
      showSign
    />
  ));

  return (
    <>
      {!!feeLines?.length && (
        <div className="above-the-line-fees">{feeLines}</div>
      )}
    </>
  );
});

export { AboveTheLineFees };

export default Fees;
